// @ts-nocheck
import React, {  useState } from 'react'
import { endpoints } from '../../utils/Constants';
import { Button} from 'reactstrap';
import { saveAs } from 'file-saver';
import useFetchSimple from '../../Services/useFetchSimple';
import LoadingAnimation from '../Form/LoadingAnimation';
import { ISupplierDocument } from '../../Models/ISupplierDocument';

const TermsAndConditionsDocument = ({ index, route, doc, refresh, supplierId }: { optional?: true, index?: string, route?: string, doc: ISupplierDocument, refresh: () => void, supplierId: string }) => {

    const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
        const byteCharacters = atob(b64Data);
        const byteArrays: Uint8Array[] = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }

    const { fileName, id } = doc;

    const fetch = useFetchSimple();
    const [gettingDocument, setGettingDocument] = useState(false);

    const downloadDoc = async () => {
        setGettingDocument(true);
        const result = await fetch(endpoints.getSupplierDocument + id);
        if (result.body) {
            const blob = b64toBlob(result.body.file, "application/pdf")
            setGettingDocument(false);
            saveAs(blob, fileName);
        }
    }
    
    return <>
        {fileName ? !gettingDocument ? < Button onClick={downloadDoc} size="sm" color="danger" >Supplier Terms and Conditions</Button> : <LoadingAnimation height='15px' /> : null}
    </>

}


export default TermsAndConditionsDocument;